// Module
var code = "<div class=\"fill\"> <ui-view></ui-view> </div>";
// Exports
module.exports = code;